import { API_CACHE_KEYS } from "api/cacheKeys";
import { useCustomQuery } from "api/useCustomQuery";
import { ListResponse } from "types/api";
import { Posicheck } from "types/imageQueries";

import { BaseQueryOptions } from "../types";

export const useGetReviewPoolService = (url: string, options: BaseQueryOptions<ListResponse<Posicheck>> = {}) =>
  useCustomQuery<ListResponse<Posicheck>>(API_CACHE_KEYS.reviewPage.pool(), url, {
    ...options,
  });

export const useReviewPoolService = (url: string, options?: BaseQueryOptions<ListResponse<Posicheck>>) => {
  const reviewPoolService = useGetReviewPoolService(url, options);
  return {
    data: reviewPoolService.data,
    get: reviewPoolService.refetch,
    isLoading: reviewPoolService.isLoading,
    isError: reviewPoolService.isError,
  };
};
